export default __webpack_public_path__ + "static/media/internet.3d15acf4.png";